import { CalculatorMetricId } from '@/utils/score-engine';

// Strict Aliases for Column Matching
export const METRIC_ALIASES: Record<CalculatorMetricId, string[]> = {
    raw: ['Resultado Bruto', 'Bruto', 'Pontos', 'Raw Score', 'Raw', 'X', 'Escore Bruto'],
    mean: ['Média', 'Mean', 'μ', 'M', 'Media', 'Média Normativa'],
    sd: ['Desvio Padrão', 'DP', 'SD', 'σ', 'S', 'Desvio Padrao', 'SD Normativo'],
    z: ['Escore Z', 'Z', 'Z-Score', 'Z Score', 'Nota Z'],
    t: ['Escore T', 'T', 'T-Score', 'T Score', 'Nota T'],
    iq: ['QI', 'IQ', 'Escore Padronizado', 'Standard Score', 'SS'],
    scaled10_3: ['Escala 10/3', 'Escore Ponderado', 'Scaled Score', 'Ponderado'],
    percentile: ['Percentil', '%', 'Percentile', 'Posto Percentílico'],
    sten: ['Sten', 'Sten Score'],
    stanine: ['Stanine', 'Stanine Score'],
    classification: ['Classificação', 'Classification', 'Classificacao', 'Interpretação', 'Faixa'],
    note: ['Obs', 'Observação', 'Note', 'Observation', 'Notas'],
};

const normalize = (s: string) => s.trim().toLowerCase();

export const findMetricId = (colName: string): CalculatorMetricId | null => {
    const norm = normalize(colName);
    for (const [id, aliases] of Object.entries(METRIC_ALIASES)) {
        // Strict exact match against aliases
        if (aliases.some((alias) => normalize(alias) === norm)) {
            return id as CalculatorMetricId;
        }
        // Strict "starts with" for complex headers like "Percentil (P)"
        // Only if followed by space or punctuation to avoid "Teste" matching "T"
        // e.g. "Percentil (Total)" -> matches "Percentil"
        if (
            aliases.some((alias) => {
                const aliasNorm = normalize(alias);
                return (
                    norm.startsWith(aliasNorm + ' ') ||
                    norm.startsWith(aliasNorm + '(') ||
                    norm.startsWith(aliasNorm + '-')
                );
            })
        ) {
            return id as CalculatorMetricId;
        }
    }
    return null;
};
